import { ErrorHandler, Injectable, isDevMode } from '@angular/core';
import { AppInsightService } from './app-insight.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService extends ErrorHandler {

  constructor(private appInsightService: AppInsightService) {
    super();
  }

  handleError(error: Error) {
    if (isDevMode()) {
      console.log(error);
    }
    else {
      this.appInsightService.logException(error);
    }
  }
}